export enum LegendType {
  SMALL,
  LARGE,
  WITH_VALUES,
}

export enum DoughnutChartColorPalette {
  DEFAULT,
  STATUS,
  INVOICE_STATUS,
  RATING,
  EMPTY,
  INCOMING_INVOICE_STATUS,
}

export enum DisplayType {
  Periodically,
  Accumulated,
}

export enum ChartDataFrequency {
  Undefined,
  Daily,
  Monthly,
  Quarterly,
  Yearly,
}

export enum MainDashBoardChartTypes {
  Sales = 0,
  Cost = 1,
  GrossMargin = 2,
  Result = 3,
}

export enum YAxisTickUnitType {
  None = 0,
  Currency = 1,
}

export enum TimelineStepType {
  NotStarted = 0,
  InProgress = 1,
  Blocked = 2,
  Delayed = 3,
  Done = 4,
}
